import React from 'react';
import Header from './components/ui/Header'
import './App.css';

const App = () => {
  return (
    <div className="container">
      <Header />
    </div>
  );
}

export default App;
